import { Point, Path, Size, Rectangle } from 'paper';
import ToolShape from '../ToolShape';

export class CutText extends ToolShape {
    constructor(boundingRectangle, font, content) {
        super('cuttext', ['delete', 'select', 'resize', 'rotate', 'move', 'text'], true);

        this.bounds = boundingRectangle;
        this.rotation = 0;
        this.font = font;
        this.content = content;
        this.fontSize = 50;
        this.autoSize = true;
    }

    get center() {
        return new Point({ x: this.centerX, y: this.centerY });
    }

    set center(center) {
        this.centerX = center.x;
        this.centerY = center.y;
    }

    get size() {
        return new Size({ width: this.sizeW, height: this.sizeH });
    }

    set size(size) {
        this.sizeW = size.width;
        this.sizeH = size.height;
    }

    get bounds() {
        return new Rectangle(new Point(this.centerX - (this.sizeW / 2), this.centerY - (this.sizeH / 2)), this.size);
    }

    set bounds(bounds) {
        this.center = bounds.center;
        this.size = bounds.size;
    }

    async updatePath() {
        let point = new Point(
            this.centerX - this.sizeW / 2,
            this.centerY - this.sizeH / 2
        );

        let path = new Path.Rectangle(
            new Rectangle(point, this.size),
            this.corner
        );

        path.rotation = this.rotation;

        this.linkTo(path);
        return path;
    }

    move(delta) {
        this.center = this.center.add(delta);
    }

    setRotation(rotation) {
        this.rotation = ((rotation + 540) % 360) - 180;
    }

    rotate(rotation) {
        this.setRotation(this.rotation + rotation);
    }

    resize(size) {
        this.size = size;
    }

    scale(ratiox, ratioy) {
        this.sizeW *= ratiox;
        this.sizeH *= ratioy;
    }

    clone() {
        let cutText = new CutText(
            this.bounds,
            this.font,
            this.content
        )
        cutText.rotation = this.rotation;
        cutText.materialFont = this.font;
        cutText.fontSize = this.fontSize;
        cutText.autoSize = this.autoSize;

        return cutText;
    }

    referencePoint(){
        let rect = new Rectangle(this.bounds.topLeft, this.size);
        let point = rect.bottomLeft;
        return point.rotate(this.rotation, rect.center);
    }
}
